import type { NetworkData } from '@dynamic-labs-sdk/client';
import { createBaseNetworkProvider } from '@dynamic-labs-sdk/client/core';

import type { SolanaNetworkProvider } from '../../SolanaNetworkProvider.types';
import { fetchSolBalance } from '../fetchSolBalance';

export const createSolanaNetworkProvider = (
  networkData: NetworkData
): SolanaNetworkProvider => ({
  ...createBaseNetworkProvider('SOL', networkData),
  cluster: networkData.cluster,
  genesisHash: networkData.genesisHash,
  getBalance: async ({ address }) => ({
    balance: await fetchSolBalance({
      address,
      networkData,
    }),
  }),
});
